const STALE_AFTER_MS = 10_000;
const pendingByChannel = new Map();

export const LATEST_JUMP_REQUESTED_EVENT = 'output:internal:latest-jump-requested';

function pruneStaleEntries(now = Date.now()) {
  for (const [channelId, requestedAt] of pendingByChannel) {
    if (now - requestedAt > STALE_AFTER_MS) pendingByChannel.delete(channelId);
  }
}

// Buffer before navigation so a main-channel feed mounted by the route change
// can consume the same intent as an already-mounted feed.
export function requestLatestJump(channelId) {
  if (!channelId) return;

  const key = String(channelId);
  const now = Date.now();
  pruneStaleEntries(now);
  pendingByChannel.set(key, now);
  window.dispatchEvent(new CustomEvent(LATEST_JUMP_REQUESTED_EVENT, { detail: { channelId: key } }));
}

export function consumeLatestJump(channelId) {
  if (!channelId) return false;

  const key = String(channelId);
  const requestedAt = pendingByChannel.get(key);
  if (requestedAt == null) return false;

  pendingByChannel.delete(key);
  return Date.now() - requestedAt <= STALE_AFTER_MS;
}
